import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Icons as I } from '../components/pack-icons';
import { writeMcpOnboardingChoice } from '../lib/connectors.js';
import { ChatGptMark, ClaudeMark, EducationStrip } from './OnboardingMcpShared.jsx';

export default function OnboardingFork() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [choice, setChoice] = useState('ui');

  const proceed = () => {
    writeMcpOnboardingChoice(choice);
    navigate(choice === 'ai' ? '/onboarding/connect' : '/onboarding?setup=ui', { replace: true });
  };

  const cards = [
    { id: 'ui', icon: <I.monitor size={20} />, title: t('mcpOnboarding.forkAppTitle'), desc: t('mcpOnboarding.forkAppDesc'), time: t('mcpOnboarding.forkAppTime') },
    { id: 'ai', title: t('mcpOnboarding.forkAiTitle'), desc: t('mcpOnboarding.forkAiDesc'), time: t('mcpOnboarding.forkAiTime') },
  ];

  return (
    <main className="mcpo-stage">
      <div className="mcpo-column">
        <section className="mcpo-fork" role="radiogroup" aria-label={t('mcpOnboarding.forkAria')}>
          <div className="mcpo-brand"><span className="mcpo-brand-mark" /><span className="mcpo-brand-word">Dathent</span></div>
          <h1>{t('mcpOnboarding.forkTitle')}</h1>
          <p className="mcpo-subtitle">{t('mcpOnboarding.forkSubtitle')}</p>
          <div className="mcpo-fork-cards">
            {cards.map((card) => (
              <button key={card.id} type="button" className="mcpo-fork-card" role="radio" aria-checked={choice === card.id} onClick={() => setChoice(card.id)}>
                <span className="mcpo-radio" aria-hidden="true" />
                {card.id === 'ai' ? (
                  <span className="mcpo-fork-assistant-icons">
                    <span className="mcpo-fork-assistant-icon mcpo-is-claude"><ClaudeMark size={32} /></span>
                    <span className="mcpo-fork-assistant-icon mcpo-is-chatgpt"><ChatGptMark size={32} /></span>
                  </span>
                ) : <span className="mcpo-fork-icon mcpo-is-ui">{card.icon}</span>}
                <h2>{card.title}</h2>
                <p className="mcpo-fork-desc">{card.desc}</p>
                <div className="mcpo-fork-meta">
                  <span className={`mcpo-meta-pill ${card.id === 'ui' ? 'mcpo-is-time' : ''}`}>{card.id === 'ui' && <I.clock size={11} />}{card.time}</span>
                </div>
              </button>
            ))}
          </div>
          <p className="mcpo-reassure">{t('mcpOnboarding.reassurance')}</p>
          <div className="mcpo-fork-actions"><button type="button" className="mcpo-primary" onClick={proceed}>{t('mcpOnboarding.continue')} <I.arrowRight size={16} /></button></div>
        </section>
        <EducationStrip />
      </div>
    </main>
  );
}
